<template>
  <v-layout row justify-center>
    <v-dialog v-model="isVisible" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="CloseDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Users and Roles</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn light flat @click="isVisible = false">Save</v-btn> -->
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-subheader>Roles</v-subheader>
            <v-row justify="center" v-if="this.roles">
              <role-card
                v-for="group in this.groups"
                :key="group.id"
                :group="group"
                :roles="roles"
                :grouproles="grouproles"
              >
              </role-card>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-container>
            <v-row>
              <v-subheader>Add user</v-subheader>
              <addNewUser :groups="this.groups" @addUser="addUser"></addNewUser>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-container>
            <v-row justify="center">
              <v-subheader>Users</v-subheader>
              <v-spacer></v-spacer>
              <v-autocomplete
                v-model="combomodel"
                prepend-inner-icon="mdi-magnify"
                :items="items"
                :search-input="search"
                class="mx-3"
                dense
                label="User"
                clearable
                outlined
                item-text="fullname"
              >
                <!-- <template v-slot:selection="{ item }">{{item.lastname}} {{item.firstname}}</template>
                <template v-slot:item="{ item }">{{item.lastname}} {{item.firstname}}</template>-->
              </v-autocomplete>
            </v-row>

            <v-row justify="center" v-if="myUsers">
              <user-card
                v-for="user in myUsers"
                :key="user.id"
                :user="user"
                :groups="groups"
                @delete="showDelete"
              ></user-card>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-if="selectedElement" v-model="selectedOpen" justify-center max-width="350px">
      <v-card color="grey lighten-4">
        <v-toolbar dark color="red">
          <v-card-title>Delete {{selectedElement.firstname}} {{selectedElement.lastname}}?</v-card-title>
        </v-toolbar>
        <v-card-actions justify-space-around>
          <v-btn dark color="grey" @click="cancel">Cancel</v-btn>
          <v-btn color="error" @click="DeleteUser(selectedElement)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <add-user-dialog ref="AddUserDialog" v-on:closeAfterSave="RefreshUserList()"></add-user-dialog>
    <delete-user-dialog ref="DeleteUserDialog" v-on:closeAfterConfirm="DeleteUser"></delete-user-dialog>-->
  </v-layout>
</template>

<script>
import axios from "axios";
// import AddUserDialog from "../dialogs/AddUserDialog";
// import DeleteUserDialog from "../dialogs/DeleteUserDialog";
import AddNewUser from "../main/user/AddNewUser";
import RoleCard from "../main/RoleCard";
import UserCard from "../main/user/UserCard";

export default {
  name: "UsersAndRolesDialog",
  components: {
    // AddUserDialog,
    // DeleteUserDialog,
    AddNewUser,
    RoleCard,
    UserCard
  },
  data: () => ({
    isVisible: false,
    groups: [],
    roles: [],
    grouproles: null,
    search: "",
    users: [],
    selectedElement: null,
    selectedOpen: false,
    items: [],
    combomodel: null
  }),

  methods: {
    addUser(user) {
      this.items.push(
        Object.assign(user, {
          fullname: `${user.firstname} ${user.lastname}`
        })
      );
    },
    showDelete(user) {
      const open = () => {
        this.selectedElement = user;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
    },

    cancel() {
      this.selectedOpen = false;
      this.selectedElement = null;
    },

    DeleteUser(user) {
      if (user.id) {
        let mutation = `mutation deleteUser($id : String!){
                          deleteUser(id : $id){
                                id
                                firstname,
                                lastname,
                                emailAddress,
                                group{
                                  id,
                                  groupName
                                }
                          }
                        }`;

        axios
          .post("/graphql", {
            query: mutation,
            variables: { id: user.id }
          })
          .then( result => {
            if (result.data.data.deleteUser) {
              this.showSuccess("User deleted!");
              let index = this.items.findIndex(u => u.id === result.data.data.deleteUser.id);
              this.items.splice(index, 1);
              this.combomodel = null;
              this.cancel();
            }
          })
          .catch(error => this.showError(error));
      }
    },

    OpenDialog() {
      const GetPageData = async () => {
        this.GetGroupRoles();
        this.GetRoles();
        this.GetGroups();
        this.GetUsers();
      };
      GetPageData();
      this.isVisible = true;
    },

    GetUsers() {
      let queryString = `query usersOfCompany($companyID: String!){
              usersOfCompany(companyID:$companyID){
                id
              firstname,
              lastname,
              emailAddress,
  						group{
                id,
                groupName
              }
              }
            }`;

      axios
        .post("/graphql", {
          query: queryString,
          variables: { companyID: this.$store.getters.user.details.companyId }
        })
        .then(res => {
          if (res.data.data.usersOfCompany) {
            this.users = res.data.data.usersOfCompany;
            let myuser = this.users.filter(
              u => u.emailAddress == this.$store.getters.user.email
            );

            if (myuser) {
              let index = this.users.indexOf(myuser[0]);
              this.users.splice(index, 1);
            }

            this.users.forEach(user => {
              this.items.push(
                Object.assign(user, {
                  fullname: `${user.firstname} ${user.lastname}`
                })
              );
            });
          }
        })
        .catch(() => {
          this.showError("Could not get users!");
        });
    },
    GetGroups() {
      let queryString = `query {
                          groups{
                            groupName,
                            id
                          }
                      }`;

      axios
        .post("/graphql", {
          query: queryString
        })
        .then(res => {
          if (res.data.data.groups) {
            this.groups = res.data.data.groups;
            // res.data.data.groups.forEach(element => {
            //   this.headers.push(
            //     Object.assign({ name: element.groupName, id: element.id })
            //   );
            // });
          }
        })
        .catch(() => {
          this.showError("Could not get groups!");
        });
    },
    GetRoles() {
      let queryString = `query {
              roles{
                roleName,
                id
              }
            }`;

      axios
        .post("/graphql", {
          query: queryString
        })
        .then(res => {
          if (res.data.data.roles) {
            this.roles = res.data.data.roles;
          }
        })
        .catch(() => {
          this.showError("Could not get roles!");
        });
    },
    GetGroupRoles() {
      let queryString = `query grouproles($companyID: String!){
              grouproles(companyID:$companyID){
                groupId,
                roleId
              }
            }`;

      axios
        .post("/graphql", {
          query: queryString,
          variables: { companyID: this.$store.getters.user.details.companyId }
        })
        .then(res => {
          if (res.data.data.grouproles) {
            this.grouproles = res.data.data.grouproles;
          }
        })
        .catch(() => {
          this.showError("Could not get Group-roles!");
        });
    },
    CloseDialog() {
      this.groups = [];
      this.roles = [];
      this.users = [];
      this.items = [];
      this.selectedElement = null;
      this.selectedOpen = false;
      this.isVisible = false;
    }
  },
  computed: {
    myUsers() {
      if (!this.combomodel) {
        return this.items;
      }
      return this.items.filter(s => s.fullname.includes(this.combomodel));
    }
  },
  watch: {
    search(val) {
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      this.items.filter(u => u.fullname.includes(val));
    }
  }
};
</script>

<style>
</style>
